export default {"src":"/_next/static/media/app_store_fr.58695431.svg","height":40,"width":127,"blurWidth":0,"blurHeight":0};